import styles from "./RecVideoSwitch.module.css";
import React, { useState, memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { AddVideoToRec, DelVideoFromRec, GetRecVideoList } from "../../homePage/HomePageActions";
import PuiMessage from "../../../components/widgets/PuiMessage";
import PSwitch from "../../../components/elements/PSwitch";
import { createStyles, makeStyles, Theme } from "@material-ui/core";

interface RecVideoSwitchProps {
    videoId: number;
    setMsg: (msg: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        msg: {
            "& .MuiSnackbar-root": {
                top: "520px",
                zIndex: 100,
            },
        },
    })
);

function RecVideoSwitch({ videoId, setMsg }: RecVideoSwitchProps) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { userInfo, recommendVideoList } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
        recommendVideoList: state.recommendList.recommendVideoList,
    }));

    //おすすめビデオトグル制御
    const [isRecVideo, setIsRecVideo] = useState<boolean>(false);

    //おすすめビデオリスト取得
    useEffect(() => {
        if (recommendVideoList.length === 0 && userInfo) {
            dispatch(GetRecVideoList(userInfo.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //おすすめビデオ登録切り替え
    useEffect(() => {
        if (recommendVideoList.length !== 0) {
            const result =
                recommendVideoList &&
                recommendVideoList.find((value) => value.id === String(videoId));
            setIsRecVideo(result ? true : false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recommendVideoList]);

    // おすすめビデオ登録切り替えトグル
    const SwitchRecVideo = () => {
        if (isRecVideo && userInfo) {
            setIsDeleteRecommendVideo(true);
            dispatch(DelVideoFromRec(videoId));
        } else {
            handleAddToRecVideo("recommendVideo");
        }
        setIsRecVideo(!isRecVideo);
    };

    const [isLimitRecommendVideos, ChangeLimitRecommendVideos] = useState(false);
    //メッセージ表示
    const [isDuplicatedRec, setIsDuplicatedRec] = useState(false);
    const [isDeleteRecommendVideos, setIsDeleteRecommendVideo] = useState(false);

    //おすすめビデオ登録
    const handleAddToRecVideo = (title: string) => {
        if (recommendVideoList) {
            let dupRec = recommendVideoList.find((el) => {
                return el.id.toString() === videoId.toString();
            });
            if (!dupRec) {
                if (recommendVideoList.length < 10) {
                    setMsg(title.split("recommendVideo").join("おすすめVideo"));
                    dispatch(AddVideoToRec(videoId.toString()));
                } else {
                    ChangeLimitRecommendVideos(true);
                }
            } else {
                setIsDuplicatedRec(true);
            }
        }
    };

    // メッセージを閉じる
    const CloseMsg = () => {
        setIsDeleteRecommendVideo(false);
    };

    const CloseLimitRecommendVideoBar = () => {
        ChangeLimitRecommendVideos(false);
    };
    const CloseDuplicateRecommendVideoBar = () => {
        setIsDuplicatedRec(false);
    };

    return (
        <>
            <div className={styles.modalTitle}>
                <img
                    alt="Thumbsup"
                    src={require("../../../../src/assets/image/thumsup.svg").default}
                />
                <p className={styles.addRecVideo}>おすすめビデオに登録</p>
                <div className={styles.switch}>
                    <PSwitch
                        id={"addRecVideo"}
                        status={isRecVideo}
                        handleClick={SwitchRecVideo}
                    ></PSwitch>
                </div>
            </div>
            <div className={classes.msg}>
                <PuiMessage
                    open={isDeleteRecommendVideos}
                    type="error"
                    title="おすすめVideoリストから削除しました"
                    duration={5000}
                    onClose={CloseMsg}
                />
                <PuiMessage
                    open={isLimitRecommendVideos}
                    type="error"
                    title="おすすめVideoは、すでに10件登録されているので追加できません"
                    duration={5000}
                    onClose={CloseLimitRecommendVideoBar}
                />
                <PuiMessage
                    open={isDuplicatedRec}
                    type="error"
                    title="このVideoは既におすすめVideoに登録されています"
                    duration={5000}
                    onClose={CloseDuplicateRecommendVideoBar}
                />
            </div>
        </>
    );
}

export default memo(RecVideoSwitch);
